import React from 'react';
import { ReactNode } from 'react';
import { CustomFormats, IntlProvider } from 'react-intl';

import './polyfill';
import messages from './locales';

import moment from 'moment';
import 'moment/locale/da';
import 'moment-duration-format';

const formats: CustomFormats = {
  time: {
    default: {
      hour12: false,
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  date: {
    default: {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    },
    short: {
      month: 'short',
      day: '2-digit',
    },
  },
  number: {
    default: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    short: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    currency: {
      style: 'currency',
      currencyDisplay: 'code',
      currency: 'DKK',
    },
    percent: {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
    unit: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
};

moment.locale('da');

export const SimpleIntlProvider = ({ children }: { children: ReactNode }) => (
  <IntlProvider
    locale="da"
    defaultLocale="en"
    messages={messages.da}
    formats={formats}
  >
    {children}
  </IntlProvider>
);
